import { request } from "./index";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import store from "@/store";
import { Toast } from "vant";
import { makeSign } from "@/util/sign";

//请求拦截器的配置
request.interceptors.request.use((config) => {
  nprogress.start();
  const public_param = store.state.public_param;
  if (public_param) {
    if (config.method === "get") {
      config.params = {
        ...public_param,
        ...config.params,
        time: Math.floor(Date.now() / 1000),
      };
    } else {
      if (config.url !== "/api/v1/system/upload-file") {
        //解决上传图片请求头设置无效问题
        config.data = {
          ...public_param,
          ...config.data,
          time: Math.floor(Date.now() / 1000),
        };
      }
    }
  }
  const signKey = "i3JuaHhe7qVURVQZSz9aWN5wvEoIygXB";
  for (const key in config.data) {
    if (config.data[key] === null) {
      config.data[key] = "";
    }
  }
  config.data["time"] = Math.round(new Date().getTime() / 1000).toString();
  config.data["sign"] = makeSign(config.data, signKey);
  return config;
});

request.interceptors.response.use(
  (response) => {
    nprogress.done();
    if (response?.data?.msg && response?.data?.msg != "ok") {
      Toast(response.data.msg);
    }
    // console.log(response)
    // console.log(response.data)
    // console.log(response.data?.data)
    if (response.data?.code === 0) {
      //code为0时请求成功
      // console.log("请求成功");
      return response.data?.data;
    } else {
      // console.log("请求失败");
      return Promise.reject({
        message: response.data?.msg,
        code: response.data?.code,
      });
    }
  },
  (error) => {
    Toast("网络错误");
    nprogress.done();
    return Promise.reject(error);
  }
);

export default request;
